"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0004 17.4988c0-2.4853 2.0147-4.5 4.5-4.5s4.5 2.0147 4.5 4.5-2.0147 4.5-4.5 4.5-4.5-2.0147-4.5-4.5zm4.5-2.5c-1.3807 0-2.5 1.1193-2.5 2.5s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5-1.1193-2.5-2.5-2.5zM6.6258 2.9768l1.7033-.0041 4.0217 6.5-.8504 1.5261h-8l-.853-1.522 3.9784-6.5zm.8575 2.43L5.285 8.9989h4.4208l-2.2224-3.592zm-4.4829 7.592h9v9h-9v-9zm2 2v5h5v-5h-5z"
  })];
};

exports.default = _default;